export default {
  "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])},
  "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
  "username": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Username"])},
  "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
  "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])},
  "captcha": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Captcha"])},
  "captchaImageHelp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter the characters on image"])}
}